import { useApi } from '../lib/useApi';

interface Dialect {
  code: string;
  language_code: string;
  name: string;
  english_name: string;
  region: string | null;
}

/**
 * Which variety of the language this is.
 *
 * Always optional, and worded so that no one's way of speaking reads as the
 * wrong one. A child taught that their grandmother's Yorùbá is a mistake
 * learns the wrong lesson entirely.
 */
export function DialectRow({ languageCode, value, onChange }: { languageCode: string; value: string; onChange: (code: string) => void }) {
  const { data } = useApi<{ dialects: Dialect[] }>(`/dialects?language=${encodeURIComponent(languageCode)}`);
  const dialects = data?.dialects ?? [];
  if (dialects.length === 0) return null;

  return (
    <label className="stack tight">
      <span className="label">Which way of speaking</span>
      <select value={value} onChange={(e) => onChange(e.target.value)}>
        <option value="">Not saying</option>
        {dialects.map((d) => (
          <option key={d.code} value={d.code}>
            {d.name} — {d.english_name}
            {d.region ? ` (${d.region})` : ''}
          </option>
        ))}
      </select>
      <span className="hint">No variety here is more correct than another. Naming it lets your grandchildren learn the language as your family actually speaks it.</span>
    </label>
  );
}
